define.alias("shared/components/shared/bttp/bttp-suggestions", "settings/components/shared/bttp/bttp-suggestions");